import React, { Component } from "react";
import { AccentColor, UpdateFav } from "../../utils/consts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UserContext } from "../../Context";

export default class ListingFav extends Component {
  updateFav = (uid, lid, add) => {
    UpdateFav(uid, lid, add)
      .then(result =>
        this.props.addFlag({
          appearance: 2,
          title: result
        })
      )
      .catch(error => {
        this.props.addFlag({
          appearance: 2,
          title: "Error - Please Try Again"
        });
      });
  };

  render() {
    return (
      <UserContext.Consumer>
        {userContext => {
          const user = userContext.user || {};
          const uid = user.uid || "";
          const my = userContext.my || {};
          const favs = my.favs || [];
          const fav = !!favs[this.props.lid];
          const lid = this.props.lid;
          return (
            <div className="fav">
              <FontAwesomeIcon
                transform="shrink-8"
                onClick={e => {
                  e.stopPropagation();
                  if (!!uid) {
                    this.updateFav(uid, lid, !!fav ? false : true);
                  } else {
                    userContext.loginModalHandler();
                  }
                }}
                className="fav__icon"
                color={AccentColor}
                size="1x"
                icon={!!fav ? "heart" : ["far", "heart"]}
              />
            </div>
          );
        }}
      </UserContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ListingFav/ListingFav.js